module.exports = __webpack_public_path__ + "static/media/kw.2e0484c0.svg";